<template>
  <div class="container-fluid">
    <div class="row">
      <showHeader
        class="col-12 mt-3"
        :image="item.image"
        :icon="'box-open'"
        :title="item.name"
        :subData="[
          {
            title: $t('Selling price'),
            value: this.$moneyFormat(item.price)
          }
        ]"
        :buttons="[
          {
            title: $t('Modulation'),
            icon: 'edit',
            link: path + '/' + $route.params.id + '/edit',
            role: $checkRole('products_edit')
          }
        ]"
      />

      <showCard
        class="col-12"
        :title="$t('Background')"
        :cloumns="{
          firstCloum: [
            {
              icon: 'box-open',
              title: $t('Product name'),
              value: item.name
            },
            {
              icon: 'layer-group',
              title: $t('Product rating'),
              value: item.section,
              type: 'link',
              to: 'section',
              link: false
            },
            {
              icon: 'terminal',
              title: $t('Product code'),
              value: item.code
            }
          ],
          scondCloum: [
            {
              icon: 'gift',
              title: $t('Product type'),
              value: item.type == 0 ? $t('product') : $t('service')
            },
            {
              icon: 'user-tie',
              title: $t('Supplier'),
              value: item.supplier,
              type: 'link',
              to: 'supplier',
              link: true
            },
            {
              icon: 'barcode',
              title: $t('Barcode'),
              value: item.barcode
            }
          ]
        }"
      />

      <showCard
        class="col-12"
        :title="$t('Accounts information')"
        :cloumns="{
          firstCloum: [
            {
              icon: 'user-tie',
              title: $t('Supplier'),
              value: item.supplier,
              type: 'link',
              to: 'supplier',
              link: true
            },
            {
              icon: 'dollar-sign',
              title: $t('Cost'),
              value: this.$moneyFormat(item.cost)
            }
          ],
          scondCloum: [
            {
              icon: 'dollar-sign',
              title: $t('sellingPrice'),
              value: this.$moneyFormat(item.price)
            },
            {
              icon: 'dollar-sign',
              title: $t('Profit'),
              value: this.$moneyFormat(item.price - item.cost)
            }
          ]
        }"
      />
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import showHeader from '@/elements/show/showHeader.vue'
import showCard from '@/elements/show/showCard.vue'

export default {
  data() {
    return {
      path: '/products',
      loaded: false,
      item: {
        supplier: null,
        store: null,
        section: null,
        unit: null
      },
      totalPages: 0,
      params: {}
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      var item = this.$database.products.find((el) => el.id == this.$route.params.id)
      if (item) {
        this.item = item
      }
      this.loaded = false
      axios
        .get(this.$linkGenerator(this.path + '/' + this.$route.params.id), {
          params: this.params
        })
        .then((response) => {
          this.item = response.data
          this.totalPages = response.data.storesHistories.last_page
          this.currentPage = response.data.storesHistories.current_page
          this.loaded = true
        })
    }
  },
  components: {
    showHeader,
    showCard
  }
}
</script>
